import { AdaptiveTheme } from "../.internal/themes/AdaptiveTheme";
export default AdaptiveTheme;
